import { Box, Button, MultiDatePicker, Stack, Typography } from "@compass/core";
import "moment-timezone";
import { useState } from "react";

export const AdditionalDates = (props: { dates: Date[]; setDates: (value: Date[]) => void }) => {
  const [showInput, setShowInput] = useState<boolean>(false);

  return (
    <Stack spacing="sm" width="100%">
      {showInput && (
        <MultiDatePicker
          label={"Additional Dates"}
          // errors={props.validationErrors[propertyName]}
          //value={props.match.creatingBulkDates}
          value={props.dates}
          onChange={(value) => props.setDates(value || [])}
        />
      )}

      {!showInput && (
        <Box>
          <Button onClick={() => setShowInput(!showInput)} variant="text" size="small">
            <Typography variant="inherit" style={{ textTransform: "none" }}>
              + Additional Dates
            </Typography>
          </Button>
        </Box>
      )}
    </Stack>
  );
};
